import getBargain from './urls/bargain';
export default function makeRequestUrl({
    blackCardDomain,
    domain,
    // lbsDomain,
    jsonConfigDomain,
    marketingDomain,
    fanxianDomain,
    vipMemberDomain,
    facadeDomain,
    adsDomain,
    privilegeDomain,
    cardDomain,
    wechatDomain, // TODO: 测试
    privilegeApiDomain,
    areaDomain,
}) {
    return {
        // 微信授权储存信息
        wechatAuthCallback: `${blackCardDomain}/app_auth/callback`,
        // 商城首页
        indexDialogApi: `${blackCardDomain}/home/index_api_top`, //首页进入弹窗信息
        homeIndexApi: `${blackCardDomain}/home/index_api`,
        filterCouponList: `${blackCardDomain}/shop-coupon/filter-data`, // 卡券筛选条件
        couponList: `${blackCardDomain}/shop-coupon/list-data`, // 卡券列表
        foodsList: `${blackCardDomain}/home/food_coupon_list`, // 餐饮优惠券列表
        fend: `${domain}/knightCard/goods/v1_0/fends`, // 栏目列表
        getFencesAndGoodsTypes: `${domain}/knightCard/goods/v1_0/getFencesAndGoodsTypes`, // 栏目列表和分类

        getZTMConfig: `${domain}/knightCard/goods/v1/ztm`, // 获取ztm信息

        search: `${blackCardDomain}/search`, // 搜索
        getSettingBYD: `${blackCardDomain}/common/get-setting`, // 获取比亚迪渠道首页特权、特权页数据
        getSetting: `${blackCardDomain}/common/get-setting`, // 获取比亚迪渠道首页特权、特权页数据

        urge: `${blackCardDomain}/urge`, // 催促上线
        geoCoding: `${blackCardDomain}/geoCoding`, // 根据经纬度获取地址
        orderNumber: `${domain}/knightCard/order/v1_0/number`, // 获取订单数量
        collectList: `${blackCardDomain}/collectList`, // 收藏列表
        banner: `${domain}/knightCard/goods/v1_0/banners`, // 根据栏目获取banner
        supplierBanner: `${domain}/knightCard/goods/v3_0/banners`, // 根据供应商返回banner
        goodTypes: `${domain}/knightCard/goods/v1_0/goodsTypes`, // 根据栏目获取分类
        recommend: `${domain}/knightCard/goods/v1_0/fend/recommend`, // 落地页商品推荐##订单完成页
        recommend2: `${domain}/knightCard/abtest/v1_0/tab/homePageGoods`, // 落地页大数据推荐接口##商城首页
        recommend3: `${domain}/knightCard/abtest/v2_0/fend/recommend`, // 大数据推荐接口（除了淘宝客外的）##商城首页
        promotionData: `${domain}/knightCard/goods/v2_0/operationSide`, // 运营推广位
        // 列表页
        getGoodsByType: `${domain}/knightCard/goods/v1_0/getGoodsByGooodsType`, // 根据商品分类获取商品
        getGoodsByTypeV2: `${domain}/knightCard/goods/v2_0/getGoodsByGooodsType`, // 根据商品分类获取商品
        getGoodsByTypeV3: `${domain}/knightCard/goods/v3_0/getGoodsByGoodsType`, // 根据商品分类获取商品
        getGoodByTypeABtest: `${domain}/knightCard/abtest/v1_0/getTaobaoGoodsByGoodsType`, // 大数据推荐淘宝客分类商品列表
        getGoodsSecType: `${domain}/knightCard/tbk/v1_0/cate/child`, // 通过一级类别获取二级类别
        getAllGoodsSecType: `${domain}/knightCard/tbk/v1_0/cate/tree`, // 通过一级类别获取二级类别

        //附近
        getShopIndex: `${blackCardDomain}/groupon/shop-index`, //商铺详情
        getTakeoutShopIndex: `${blackCardDomain}/take-out/shop-index`, //商铺详情
        getShopDealDetail: `${blackCardDomain}/groupon/shop-deal-detail`, //团单详情
        grouponOrderList: `${blackCardDomain}/groupon/order-list`, //周边订单列表
        grouponOrderDetail: `${blackCardDomain}/groupon/order-detail`, //周边订单详情
        grouponOrderDelete: `${blackCardDomain}/groupon/order-delete`, //删除周边订单
        grouponOrderRefund: `${blackCardDomain}/groupon/order-refund`, //订单退款
        grouponOrderRefundProgress: `${blackCardDomain}/groupon/order-refund-progress`, //订单退款

        // 淘宝客提示
        getTbkTip: `${domain}/knightCard/tip/v1_0/info`,

        // 搜索页
        searchFend: `${domain}/knightCard/goods/v1_0/search_fends`, // 搜索栏目列表
        searchAllGoods: `${domain}/knightCard/opensearch/v1_0/searchAllGoods`,
        searchBySupplerId: `${domain}/knightCard/opensearch/v1_0/searchBySupplerId`,
        searchBySupplerId2: `${domain}/knightCard/abtest/v1_0/searchBySupplerId`,
        searchAll: `${domain}/knightCard/abtest/v1_0/tab/searchAll`,
        searchWphByLink: `${fanxianDomain}/api/wph/v1_0/link/search`,
        // 大数据搜索推荐
        searchTBK: `${fanxianDomain}/api/tbk/v1_0/searchTbk`,
        searchTbkFromPyp: `${domain}/knightCard/abtest/v1_0/searchTbk`,
        suggest: `${domain}/knightCard/opensearch/v2_0/suggest`,

        bigDataSuggest: `${facadeDomain}/search/v1/suggestWord`, //这个需求的
        // bigDataSuggest: `${domain}/knightCard/opensearch/v4_0/suggest`,//今天上的联想词2.0

        searchPrivilege: `${blackCardDomain}/advertise/search`,
        discern: `${domain}/knightCard/tbk/v1_0/discern`, //搜索淘宝客数据

        depot: `${domain}/knightCard/tbk/v1_0/depot/search`, // 选品库搜索,
        material: `${domain}/knightCard/tbk/v1_0/search`,
        searchLoopWord: `${domain}/knightCard/opensearch/v2_0/rollHotWord`, // 搜索滚动词
        searchHotWord: `${domain}/knightCard/opensearch/v2_0/hotWord`, //搜索热词
        searchRecommendSection: `${domain}/knightCard/abtest/v1_0/searchEmptyRecommend`, // 搜索为空时，推荐精选商品
        searchRecommendOfCPS: `${fanxianDomain}/api/material/items/choice/search`, // 搜索为空时，推荐cps精选商品
        getAlbumList: `${fanxianDomain}/api/album/v1_0/getAlbumList`, // 获取专辑列表
        getAlbumDetail: `${fanxianDomain}/api/album/v1_0/getAlbumDetail`, // 获取专辑详情
        // 地址组件
        getAddress: `${domain}/knightCard/address/v1_0/user/get`,
        defaultAddress: `${domain}/knightCard/address/v1_0/user/set_default`,
        getAreaData: `${domain}/knightCard/address/v1_0/getAddress`,
        saveAddress: `${domain}/knightCard/address/v1_0/user/add`,
        editAddress: `${domain}/knightCard/address/v1_0/user/modify`,
        deleAddress: `${domain}/knightCard/address/v1_0/user/delete`,
        importWechatAddress: `${domain}/knightCard/wechatApp/v2_0/importRecord`, // 导入微信地址
        judgeUserAddressNeedUpdate: `${domain}/knightCard/wechatApp/v2_0/user/needToUpdateAddress`, // 判断用户的地址是否需要更新

        // 商品详情页
        getGoodsDetail: `${domain}/knightCard/goods/v2_0/goodsDetail`,
        zeroPurchaseGoodsDetail: `${domain}/knightCard/goods/v1_0/shopZeroPurchaseGoodsDetail`,
        getSeckillIsNotice: `${domain}/knightCard/activity/v1_0/goods/isNotice`,
        getSingleGoodsDetail: `${domain}/knightCard/promotion/v1_0/goods_detail`,
        getGoodsUserLimit: `${domain}/knightCard/goods/v1_0/goodsUserLimit`,
        getGoodsUserCollect: `${domain}/knightCard/goods/v1_0/goodsUserDetail`,
        getSkuPrice: `${domain}/knightCard/order/v1_0/feeQuery`,
        getGoodsDetailImgsList: `${domain}/knightCard/goods/v1_0/imgs`,
        checkPro: `${domain}/knightCard/goods/v1_0/checkPro`,
        getTemplate: `${domain}/knightCard/goods/v1_0/explain_template`,
        getDetailRecommend: `${domain}/knightCard/goods/v1_0/detailRecommend`,
        getDetailRecommendABTest: `${domain}/knightCard/abtest/v1_0/getGoodsBySellEmpty`,
        getDetailSeeAndSeeAbTest: `${domain}/knightCard/abtest/v2_0/getGoodsBySellEmpty`, // 详情页，看了又看
        getGoodsNotification: `${domain}/knightCard/goods/v1_0/goodsNotification`,
        getCoinExplain: `${domain}/knightCard/currency/v1_0/explain`, // 商品详情关于骑士币的说明
        getDetailCoupon: `${domain}/knightCard/goods/v1_0/coupon/detail`, // 商品详情 获取优惠券
        getDetailCouponV2: `${domain}/knightCard/goods/v2_0/coupon/detail`, // 商品详情 获取优惠券
        getNewTaobaoDetailAbTest: `${domain}/knightCard/abtest/v1_0/getCpsCartFlag`, // 新版淘宝cps abtest
        // 获取大概预估价格
        getAnEstimatedPrice: `${domain}/knightCard/order/v1_0/prize/huabei/detail`,
        // 商品详情-商品规格
        getKnowledge: `${domain}/knightCard/goods/v1_0/knowledge/`,
        // 商品详情-根据价格获取分期
        getHuabeiInstallmentList: `${domain}/knightCard/goods/v1_0/getHuabeiInfo`,
        // 砍价模式 获取详情
        cutPriceGetGoodsDetail: `${domain}/knightCard/bargain/v1_0/bargain_activity_detail`,
        // 砍价模式 商品须知
        cutPriceGetTemplate: `${domain}/knightCard/bargain/v1_0/explain_template`,

        // 商品详情页2（淘宝客商品详情页）
        tbGetGoodsDetail: `${domain}/knightCard/goods/v1_0/tbk/goodsDetail`,
        tbRecommend: `${domain}/knightCard/tbk/v1_0/getRecommendItems`,

        // 品牌列表
        getGoodsRespListByBrand: `${domain}/knightCard/brand/v1_0/brandGoodsList`,

        // 支付页
        getDefaultlAddress: `${domain}/knightCard/address/v1_0/user/query_default`,
        getPriceDetail: `${domain}/knightCard/order/v1_0/prize/detail`,
        payQuery: `${domain}/knightCard/order/v1_0/payQuery`,
        payQueryGroup: `${domain}/knightCard/groupPurchase/v1_0/payQuery`, // 拼团
        payAppJson: `${domain}/knightCard/pay/v1_0/callback/payjson`,
        // 支付完成大数据推荐商品
        paySuccessRecommendBusiness: `${domain}/knightCard/abtest/v7_0/selective`,
        // 支付页 v1.3
        getPriceDetailv2: `${domain}/knightCard/order/v2_0/prize/detail`,

        needToUpdateAddress: `${domain}/knightCard/address/v1_0/user/needToUpdateAddress`,

        // 拼团支付页
        getGoodsDetailGroup: `${domain}/knightCard/groupPurchase/v1_0/prize_detail`,

        // 订单页
        getOrderDetail: `${domain}/knightCard/order/v1_0/detail`,
        getLogistics: `${domain}/knightCard/order/v1_0/logistics/detail`,
        getOrderRecommend: `${domain}/knightCard/order/v1_0/recommend`,
        getOrderList: `${domain}/knightCard/order/v1_0/list`,
        expediteDelivery: `${domain}/knightCard/order/v1_0/expedite_delivery`,
        submitPay: `${domain}/knightCard/order/v1_0/create`,
        confirmReceipt: `${domain}/knightCard/order/v1_0/confirm_receipt`,
        // 订单页v1.2
        getOrderListV3: `${domain}/knightCard/order/v1_0/list_by_parent`, // 通过父订单查询子订单 目前仅用于gio埋点
        getOrderListV2: `${domain}/knightCard/order/v2_0/list_new`,
        getOrderDetailV2: `${domain}/knightCard/order/v1_0/detail_new`,
        getUnBuyOrderDetailV2: `${domain}/knightCard/order/v1_0/detail_un_buy`,
        getPrivilegeList: `${blackCardDomain}/customOrder/index`,
        getPrivilegeListChildren: `${blackCardDomain}/customOrder/children`,
        getPageNotification: `${domain}/knightCard/goods/v1_0/page_notification`,
        // 订单v1.3
        submitPayV2: `${domain}/knightCard/order/v1_0/create_by_cart`,
        createOrderGroup: `${domain}/knightCard/groupPurchase/v1_0/create_order`,
        submitUnBuyPayV2: `${domain}/knightCard/order/v1_0/pay`,
        submitPayForNoToken: `${domain}/knightCard/promotion/v1_0/create_order`,
        submitPayAgainForNoToken: `${domain}/knightCard/promotion/v1_0/pay_order`,
        checkGoodssingleBuySupport: `${domain}/knightCard/order/v1_0/order/create/check`,
        // 订单页
        cancelPendingOrder: `${domain}/knightCard/order/v1_0/cancelPendingOrder`,
        // 检测是否可修改地址
        checkOrderAddress: `${domain}/knightCard/order/v1_0/checkOrderAddress`,
        // 获取订单收货人地址
        getOrderAddress: `${domain}/knightCard/order/v1_0/getOrderAddress`,
        // 获取订单收货人地址
        updateOrderAddress: `${domain}/knightCard/order/v1_0/updateOrderAddress`,

        //拼团详情
        getGroupDetail: `${domain}/knightCard/groupPurchase/v1_0/groupDetail`,

        // 订单页-会员积分
        getUserCurrency: `${domain}/knightCard/currency/v2_0/info`,
        // 订单页-返现余额以及使用规则
        getUserFanxianConfig: `${domain}/knightCard/order/v1_0/fanxian_config`,
        // 订单列表页-底部大数据商品推荐
        getOrderRecommendBusiness: `${domain}/knightCard/abtest/v6_0/selective`,
        // 返现余额
        getUserCommission: `${fanxianDomain}/api/commission/v1_0/withdraw/summary`,
        // 骑士币列表
        getCurrencyList: `${domain}/knightCard/currency/v1_0/list`,
        // 获取骑士币资格
        qualifyCurrency: `${domain}/knightCard/currency/v1_0/qualify`,
        // 获取当前用户活动骑士币数量
        receiveCurrency: `${domain}/knightCard/currency/v1_0/receive`,

        // 新收银台app接口
        getAppPayInfo: `${blackCardDomain}/app/to_pay`,
        getPayInfo: `${domain}/knightCard/pay/v1_0/payinfo/get`,

        // 获取token
        getToken: `${domain}/knightCard/user/v1_0/getToken`,
        getAppToken: `${domain}/knightCard/user/v1_0/getAppToken`,

        // 添加心愿单
        addWishList: `${domain}/knightCard/user/v1_0/addWishList`,

        // 充值页面
        getRechargeInfo: `${blackCardDomain}/recharge/index`,
        getOrderInfo: `${privilegeDomain}/recharge/order/v1/payFinish`,
        getOrderPayStatus: `${blackCardDomain}/recharge/check_order_paid`,

        // 购物车模块
        addToCart: `${domain}/knightCard/cart/v1_0/add`,
        deleteFromCart: `${domain}/knightCard/cart/v1_0/del`,
        editCart: `${domain}/knightCard/cart/v1_0/edit`,
        // getCartList: `${domain}/knightCard/cart/v1_0/myCartList`,
        getCartList: `${domain}/knightCard/cart/v1_0/myCartResult`,
        getCartResultV2: `${domain}/knightCard/cart/v2_0/myCartResult`,
        // 2021-01-14 ios post会干掉body，改为get
        getCartRecommend: `${domain}/knightCard/goods/v1_1/cart/recommend`,
        getCartRecommendV2: `${domain}/knightCard/goods/v2_0/cart/recommend`,
        addToCartBySku: `${domain}/knightCard/cart/v1_0/addsku`,

        // getTqczDetail: `${blackCardDomain}/recharge/order_list`,
        getTqczDetail: `${privilegeDomain}/recharge/order/v1/orderDetail`,

        // 退出登陆
        logout: `${blackCardDomain}/logout`,

        // 评论模块
        comment: `${domain}/knightCard/comment/v2_0/add`,
        getComment: `${domain}/knightCard/comment/v1_0/goodsCommentList`,
        getCommentTotal: `${domain}/knightCard/comment/v1_0/goodsCommentAmount`,
        getCommentDetail: `${domain}/knightCard/comment/v1_0/detail`,

        // 售后模块 ---------------
        // 取消售后申请
        cancelAfterSales: `${domain}/knightCard/refund/v1_0/apply/cancel`,
        // 售后详情
        getAfterSalesDetail: `${domain}/knightCard/refund/v1_0/apply/detail`,
        // 售后列表:申请中和已完成
        getAfterSalesList: `${domain}/knightCard/refund/v1_0/apply/list`,
        // 获取售后红点数量
        getAfterSalesNum: `${domain}/knightCard/refund/v1_0/apply/redNum`,
        // 修改消息是否已读
        messageUpdate: `${domain}/knightCard/refund/v1_0/message/status/update`,
        // 添加补充信息
        messageAdd: `${domain}/knightCard/refund/v1_0/message/add`,
        // 获取售后邮寄地址
        getAfterSalesAddress: `${domain}/knightCard/refund/v1_0/getLogistics`,
        // 获取退货类型信息
        getAfterSalesRefundType: `${domain}/knightCard/refund/v1_0/getRefundType`,
        // 获取退货信息
        // getAfterSalesRefund: `${domain}/knightCard/refund/v1_0/getRefundSku`,
        getAfterSalesRefund: `${domain}/knightCard/refund/v2_0/getRefundSku`,
        // 添加售后申请信息
        addAfterSales: `${domain}/knightCard/refund/v1_0/info/add`,
        // 编辑售后申请信息
        editAfterSales: `${domain}/knightCard/refund/v1_0/info/edit`,
        // 重新添加售后申请信息
        reAddAfterSales: `${domain}/knightCard/refund/v1_0/info/reAdd`,
        // 填写物流信息
        addAfterSalesLogistics: `${domain}/knightCard/refund/v2_0/setLogistics`,
        updateAfterSalesLogistics: `${domain}/knightCard/refund/v2_0/updateLogisticsAgain`,
        // 获取物流公司列表
        getAfterSalesLogisticsCompany: `${domain}/knightCard/refund/v1_0/info/getLogisticsCompany`,
        // 售后列表:售后申请
        unAfterSalesList: `${domain}/knightCard/refund/v1_0/unApplyList`,
        // 骑士卡取消退款模块
        refundCostApply: `${domain}/knightCard/refundCost/v1_0/apply`,
        // 骑士卡退款详情
        refundCoseDetail: `${domain}/knightCard/refundCost/v1_0/detail`,
        // 检查是否可以申请退款
        judgeCancel: `${domain}/knightCard/refundCost/v1_0/judgeCancel`,
        // 用户取消退款
        refundCancelOrder: `${domain}/knightCard/refundCost/v1_0/user_cancel_order`,
        userCancelRecall: `${domain}/knightCard/refundCost/v1_0/user_cancel_recall`,

        // 取消订单金额明细
        getMoneyDetailOfRefund: `${domain}/knightCard/refundCost/v1_0/money/detail`,

        // 售后金额明细
        getMoneyDetailOfAfterSale: `${domain}/knightCard/refund/v1_0/money/detail`,

        // 检查是否支持售后
        checkAfterSales: `${domain}/knightCard/refund/v1_0/apply/check`,
        // 售后是否必传图片V2
        getGoodsRefundTemplateV2: `${domain}/knightCard/refund/v2_0/getGoodsRefundTemplateNewV2`,

        goodsDetail4Aftersale: `${domain}/knightCard/goods/v1_0/goodsDetail4Aftersale`,
        checkPro4Aftersale: `${domain}/knightCard/goods/v1_0/checkPro4Aftersale`,
        getLogisticsDetail: `${domain}/knightCard/refund/v1_0/logistics/detail`,

        // 售后模块 end ---------------

        // 文件模块 上传
        upload: `${domain}/knightCard/file/v1_0/upload`,

        // 我的页二维码
        // 首页
        homePrivilege: `${domain}/knightCard/goods/v1_0/homePagePrivileges`,
        // 首页推荐特权tab的特权、banner用php接口
        homePrivilegePhp: `${blackCardDomain}/advertise/get-entry`,
        isAppUser: `${blackCardDomain}/common/is-app-user`,
        // homeGoods: `${domain}/knightCard/goods/v1_0/homePageGoods`,
        homeGoods: `${domain}/knightCard/goods/v1_0/newHomePageGoods`,
        // 爱库存商品接口
        homeAKCGoods: `${domain}/knightCard/goods/v1_0/newHomePageSeckillGoods`,

        qrcode: `${domain}/knightCard/user/v1_0/getWechatImg`,
        homePageTabs: `${domain}/knightCard/goods/v1_0/homePageTabs`,
        // 特权分接口
        privilegePoint: `${domain}/knightCard/user/v1_0/getPoints`,

        // 获取是否新用户接口
        isNewUser: `${domain}/knightCard/user/v1_0/newcomer`,

        // 我的-帮助与客服页
        customServiceHelp: `${blackCardDomain}/custom_service_help/index`,
        // 活动
        jsCashBackBeforeExchange: `${blackCardDomain}/jd_code/exchange`,
        jsCashBackDoExchange: `${blackCardDomain}/jd_code/exchange_act`,
        // 兑换券(星巴克,kfc等)
        lastUnpaidOrder: `${blackCardDomain}/ticket/last-unpaid-order`,
        ticketBrandList: `${blackCardDomain}/ticket/brand-list`,
        ticketList: `${blackCardDomain}/ticket/ticket_list`,
        ticketIndex: `${blackCardDomain}/ticket/index`,
        ticketAppointment: `${blackCardDomain}/ticket/appointment`,
        ticketAddOrder: `${blackCardDomain}/ticket/add_order`,
        ticketAddOrderV2: `${privilegeApiDomain}/ticket/order/v1/add`,
        ticketOrderDetail: `${blackCardDomain}/ticket/order_detail`,
        ticketOrderList: `${blackCardDomain}/ticket/order-list-v1`,
        ticketCheckPaid: `${blackCardDomain}/ticket/check_paid`,
        checkSeckillPaid: `${blackCardDomain}/ticket/check-seckill-paid`,
        ticketCheckUnpaid: `${blackCardDomain}/ticket/check-unpaid`,

        ticketHotTicket: `${blackCardDomain}/ticket/hot-ticket`,
        // 每日红包(抽奖)
        // 注意这里有多域名问题， 不能直接写死地址
        dailyLotteryPrize: `/daily_lottery/prize_list`,
        dailyLotteryDraw: `/daily_lottery/draw`,
        dailyLotteryShare: `/daily_lottery/share_ecard`,
        dailyLotteryisParent: `/daily_lottery/is_parent`,
        dailyLotteryBanner: `/advertise/get-entry?pageTag=choujiang`,
        // dailyLotteryDelete: `${blackCardDomain}/daily_lottery/delete`, // TODO: delete
        // 收藏模块
        addCollection: `${domain}/knightCard/collect/v1_0/addCollect`,
        delCollection: `${domain}/knightCard/collect/v1_0/delCollect`,
        collectionList: `${domain}/knightCard/collect/v1_0/list`,

        // 特权收藏模块
        privilegeCollect: `${blackCardDomain}/coupon/collect`,
        privilegeCollectList: `${blackCardDomain}/coupon/collectList`,
        privilegeCancelCollect: `${blackCardDomain}/coupon/cancelCollect`,
        privilegeCollectStatus: `${blackCardDomain}/coupon/collectStatus`,

        // 个人信息录入页
        getUserInfo: `${blackCardDomain}/member/info`,
        saveUserInfo: `${blackCardDomain}/member/saveinfo`,
        saveNickName: `${blackCardDomain}/member/save-nickname`, //修改昵称
        uploadAvatar: `${blackCardDomain}/member/upload-avatar`, //上传头像
        // 获取用户信息，通过骑士卡black-token
        getBlackUniqueUserInfo: `${blackCardDomain}/common/get-user-info`,
        // 用户自动升级会员
        userUpGrade: `${facadeDomain}/app/uc/v1/upgradeToMember`,

        // 京粉-----
        // 获取京粉首页商品
        getJdfIndexList: `${domain}/knightCard/jdf/v2_0/getJdfIndexList`,
        getGoodsByGooodsType: `${domain}/knightCard/jdf/v2_0/getGoodsByGooodsType`,

        // 频道页---
        // 京粉频道页商品
        getGoodsByTypeChannelJD: `${fanxianDomain}/api/jdjf/v1_0/queryJFGoods`,
        getChannelJD: `${fanxianDomain}/jdfChannel/v1_0/queryChannel`,

        // jd选品库搜索
        jdfSearch: `${domain}/knightCard/jdf/v1_0/depot/search`,
        // jd大数据推荐搜索
        jdfABtestSearch: `${domain}/knightCard/jdf/v1_0/keyword/search`,
        // jd物料搜索（超15字使用）
        jdfKeyword: `${domain}/knightCard/jdf/v1_0/keyword/search`,
        // jd 链接搜索
        jdLinkSearch: `${domain}/knightCard/jdf/v1_0/link/search`,
        // jd商品详情
        jdGoodDetail: `${domain}/knightCard/goods/v1_0/jdf/goodsDetail`,
        // jdLink: `${domain}/knightCard/jdf/v2_0/promotion/link`,
        jdLink: `${fanxianDomain}/JDChannel/v3_0/promotion/link`,
        jdChannelLink: `${fanxianDomain}/JDChannel/v2_0/promotion/link`,
        // 考拉赚客-----

        // 首页商品
        getZkIndexList: `${domain}/knightCard/goods/v1_0/klzk/getKLZKIndexList`,
        // 通过分类获取商品
        getZkGoodsByGoodsType: `${domain}/knightCard/goods/v1_0/klzk/getKLZKGoodsByGoodsType`,
        // 获取分类
        getZkGoodsType: `${domain}/knightCard/goods/v1_0/klzk/getKLKZGoodsType`,
        // zk商品详情页
        zkGoodDetail: `${domain}/knightCard/goods/v1_0/klzk/getKLZKGoodsDetail`,
        // zk 搜索
        zkSearch: `${fanxianDomain}/api/app/kaola/v1/searchGoodsByKeywords`,
        zkLink: `${domain}/knightCard/goods/v1_0/search/linkSearch`,

        // 苏宁详情
        getSNGoodsDetail: `${fanxianDomain}/api/suning/v1_0/getSNGoodsDetail`,

        // PDD 搜索
        pddGoodsList: `${domain}/knightCard/duoduoke/v1_0/getGoodsByGooodsType`,
        pddSearch: `${domain}/knightCard/spreader/v1_0/keyword/search`,
        snSearch: `${fanxianDomain}/api/suning/v1_0/keyword/search`,
        // 大数据cps搜索:PDD、vip
        pddABtestSearch: `${fanxianDomain}/api/duoduoke/abtest/v1_0/keyword/search`,
        vipABtestSearch: `${fanxianDomain}/api/wph/abtest/v1_0/keyword/search`,
        vipLink: `${domain}/knightCard/spreader/v1_0/link/search`,
        pddGoodDetail: `${domain}/knightCard/spreader/v1_0/goodsDetail`,
        vipGoodDetail: `${fanxianDomain}/api/knightCard/spreader/v1_0/goodsDetail`,
        pddGetPromotionUrl: `${domain}/knightCard/spreader/v1_0/getPromotionUrl`,
        snGetPromotionUrl: `${fanxianDomain}/api/suning/v1_0/getPromotionUrl`,
        getSnMiniPromotionUrl: `${fanxianDomain}/api/suning/v1_1/getPromotionUrl`,
        // 唯品首页会推广链接
        vipGetPromotionUrl: `${domain}/knightCard/spreader/v1_0/wph/getHomePagePromotionUrl`,

        // 单品推广模块
        singleGoods: singleGoods({ blackCardDomain, domain }),

        // 超市推广
        superMarket: superMarket({ blackCardDomain, domain }),
        // 淘礼金
        tBounty: tBounty({ domain }),
        // poi 代理
        poiProxy: `${domain}/poi`,
        getIpConfig: `${domain}/knightCard/tbk/v1_0/ipConfig`,
        getCityList: `${domain}/knightCard/address/v1_0/poi/get`,
        getHotCityList: `${domain}/knightCard/address/v1_0/poi/getHotCity`,
        getCityListV2: `${areaDomain}/areaList/v1/get`,
        getHotCityListV2: `${areaDomain}/areaList/v1/getHotCity`,
        getCityByPosition: `${areaDomain}/location/v1/place/region`,

        // 广告位-获取全部模块和入口接口 (不同模块使用不同参数)
        getAdvertiseEntry: `${blackCardDomain}/advertise/get-entry`,
        // 广告位2.0
        newAdvertise: `${adsDomain}/advertise/v1/get`,
        // 获取积分兑换联登链接
        integralUrl: `${privilegeDomain}/point/unionLogin/v1/getUrl`,
        // 获取积分兑换骑士币记录
        integralRecord: `${privilegeDomain}/point/exchangeCoin/v1/getRecord`,
        // 麦当劳连接
        mcdonaldOrderUrl: `${blackCardDomain}/mcdonald/order/urls`,
        // abtest接口
        // 首页商品(精选推荐)
        abHomePageGoods: `${domain}/knightCard/abtest/v1_0/homePageGoods`,
        // 首页商品(精选推荐 供应商商品+cps商品+0元购【前三个】)
        abHomePageGoodsMix: `${domain}/knightCard/abtest/v5_0/selective`,
        // 大数据推荐商品
        getBigDataStatsGoods: `${domain}/knightCard/abtest/v3_0/selective`,

        // 首页营销专区banner
        getMarketBanner: `${domain}/knightCard/goods/v2/market`,

        // 优惠券
        shopCouponLabel: `${domain}/knightCard/coupon/v1_0/couponLabel`,
        // 2021-01-14 ios post会干掉body，改为get
        shopCouponList: `${domain}/knightCard/coupon/v2_0/list`,
        exchangeCouponByCode: `${domain}/knightCard/coupon/v1_0/exchangeCouponByCode`,
        exchangeCouponByCodeV2: `${domain}/knightCard/coupon/v2_0/exchangeCouponByCode`,
        exchangeCaptcha: `${domain}/knightCard/coupon/v1_0/exchange_captcha`,
        shopCouponBanner: `${domain}/knightCard/coupon/v1_0/bannerUrl`,
        shopCouponActiveIndex: `${domain}/knightCard/coupon/v2_0/activityIndex`,
        shopCouponReceive: `${domain}/knightCard/coupon/v1_0/receiveCoupon`,
        showCouponNumber: `${domain}/knightCard/coupon/v1_0/availableCouponNum`,
        getGoodsByCoupon: `${domain}/knightCard/goods/v2_0/getGoodsByCoupon`, // 获取优惠券凑单商品
        calcCartAmountByCartId: `${domain}/knightCard/coupon/v1_0/calcCartAmountByCartId`, // 凑单接口小计
        searchByCouponId: `${domain}/knightCard/opensearch/v1_0/searchByCouponId`, // 凑单商品搜索接口
        queryPackageAmount: `${domain}/knightCard/coupon/v1_0/queryPackageAmount`, // 支付后获取优惠券金额
        receiveByPaySuccess: `${domain}/knightCard/coupon/v1_0/receiveByPaySuccess`, // 支付后获取优惠券
        receiveCouponByPackage: `${domain}/knightCard/coupon/v1_0/receiveCouponByPackage`,
        queryCouponByGoodsId: `${domain}/knightCard/coupon/v1_0/queryCouponByGoodsId`,

        // 骑士卡优惠券接口
        // 详情页可领取以及已领取的优惠券
        cardGetDetailCoupon: `${blackCardDomain}/shop/coupon/can-pick-list`,
        // 骑士卡领取优惠券
        cardCouponReceive: `${privilegeApiDomain}/shopCoupon/v1/pick`,
        // 某个商品可使用的优惠券
        cardCouponAvailableList: `${privilegeDomain}/shopCoupon/v1/availableList`,

        // 首页商品(非精选推荐)
        abHomePageGoods2: `${domain}/knightCard/abtest/v1_0/newHomePageGoods`,

        getFreePickGoodList: `${domain}/knightCard/goods/v1_0/combined`, // 获取n元任选凑单页商品列表
        calcFreePickCartAmount: `${domain}/knightCard/saleActivity/v1_0/calcCartSale`, // 获取n元任选凑单页购物车金额
        getFreePickInfo: `${domain}/knightCard/saleActivity/v1_0/info`, // 获取n元任选活动信息

        // 支付完成运营推广位 获取banner图列表  api: http://yapi.corp.zuzuche.info/project/533/interface/api/8953
        operationBanner: `${blackCardDomain}/banner/list`,

        // 秒杀相关接口

        seckillActivityJSON: `${jsonConfigDomain}/seckillActivity.json`,

        // 大牌秒杀 home页
        // 品牌
        homeAKCGoodsV2: `${domain}/knightCard/activity/v1_0/zones/brands`,
        // 推荐
        seckillZonesGoods: `${domain}/knightCard/activity/v1_0/zones`,
        // 分类
        seckillZonesMenu: `${domain}/knightCard/activity/v1_0/classifications`,
        // 分类商品
        getSecGoodsByType: `${domain}/knightCard/activity/v1_0/classifications/goods`,

        // 大牌秒杀 活动页
        seckillZoneActivity: function(name) {
            return `${domain}/knightCard/activity/v1_0/${name}`;
        },
        // 大牌秒杀 品牌页
        seckillBrand: `${domain}/knightCard/activity/v1_0/brands`,
        seckillBrandGoods: `${domain}/knightCard/activity/v1_0/brands/goods`,
        // 大牌秒杀详情页排队token
        seckillToken: `${domain}/knightCard/activity/v1_0/seckill/token`,
        // 秒杀商品提醒功能
        seckillBook: `${domain}/knightCard/activity/v1_0/goods/apppush`,

        // 整点秒杀活动列表
        hoursSeckill: `${domain}/knightCard/activity/v1_0/hours`,
        // 整点秒杀商品
        hoursSeckillGoods: `${domain}/knightCard/activity/v1_0/hours/goods`,
        // 整点秒杀商品会员购买列表
        hoursGoodsBuyRecord: `${domain}/knightCard/activity/v1_0/hours/goodsBuyRecord`,

        // 秒杀app提醒推送
        seckillGoodsPush: `${domain}/knightCard/activity/v2_0/goods/apppush`,

        // 整点秒杀
        operationMenuColumn: `${domain}/knightCard/operationMenuColumn/get`,
        hourSeckillSelective: `${domain}/knightCard/abtest/v1_0/hourSpike/selective`,
        // 整点秒杀淘宝客检查
        hourSeckillCheckTBK: `${fanxianDomain}/api/seckill/v1_0/check`,
        // 整点秒杀淘宝客抢购名额
        hourSeckillGetCouponTBK: `${fanxianDomain}/api/seckill/v1_0/getCoupon`,
        // 整点秒杀淘宝客商品详情
        hourSeckillDetailTBK: `${fanxianDomain}/api/seckill/v1_0/goods/detail`,

        // 整点秒杀淘宝客获取已抢到人员名单
        hourSeckillGetSuccessUsers: `${fanxianDomain}/api/seckill/v1_0/getSuccess/user/list`,

        saveDeatals: `${domain}/knightCard/tbk/v1_0/saveDetails`,

        ...getBargain({ domain, marketingDomain }),
        // 省钱宝
        filing: `${domain}/knightCard/sqb/v1_0/filing`,
        memberFiling: `${domain}/knightCard/sqb/v2_0/filing`,
        checkFiling: `${domain}/knightCard/sqb/v1_0/check`,
        // 尊享特权页
        getPrivilegePage: `${blackCardDomain}/advertise/get-entry`,
        //特权页abtest
        getPrivilegeABTest: `${domain}/knightCard/abtest/v1_0/privilege/flag`,

        // 自定义浮标与弹框
        getCustomIcon: `${domain}/knightCard/goods/v3_0/buoy`,
        getCustomPopup: `${domain}/knightCard/goods/v3_0/popup`,

        //新用户banner
        newHand: `${domain}/knightCard/goods/v2_0/newHand`,

        //极校验初始化api
        geetestRegister: `${blackCardDomain}/gt/register-slide`,

        // 通过手机号自动登录
        authByPhone: `${blackCardDomain}/auth-by-phone`,
        authByShopToken: `${blackCardDomain}/auth-by-shop-token`,
        // 生成淘宝口令
        createPwd: `${domain}/knightCard/tbk/v1_0/creat_pwd`,
        // 生成淘宝口令V2
        createPwdV2: `${domain}/knightCard/tbk/v2_0/creat_pwd`,

        getOssPolicy: `${domain}/knightCard/file/v1_0/getOssPolicy`,
        getVideoAuthUrl: `${domain}/knightCard/file/v1_0/getVideoAuthUrl`,

        // 一键公告
        getAnnouncement: `${domain}/knightCard/announcement/v2_0/get`,

        getMessageList: `${domain}/knightCard/message/v1_0/list`,
        getMessageNotReadNum: `${domain}/knightCard/message/v1_0/countNotReadNum`,
        getMessageLatest: `${domain}/knightCard/message/v1_0/latest`,
        getMessageTabList: `${domain}/knightCard/message/v1_0/tabList`,

        // 获取服务器时间
        getServerTime: `${domain}/knightCard/commonRest/v1_0/getServerTime`,
        // 0元购商品
        // freeBuyGoods: `${domain}/knightCard/abtest/v5_0/free_purchase/goods`,
        // 0元购用户资格
        freeBuyQualification: `${fanxianDomain}/zeroShop/v1/right`,
        // 0元购商品接口域名更改，12.29
        freeBuyGoods: `${fanxianDomain}/zeroShop/v5/goods`,
        // 聚合接口的0元购
        freeBuyGoodsByPhp: `${facadeDomain}/zeroShop/v1/goodsList`,
        // 聚合接口的0元购
        freeBuyGoodsByPhpMini: `${facadeDomain}/mini/zeroShop/v1/goodsList`,
        // 整点秒杀页面0元购商品列表
        freeBuyGoodsForHourSeckill: `${fanxianDomain}/zeroShop/v6/goods`,
        // 获取用户0元购资格和活动剩余时间
        freeBuyQuota: `${fanxianDomain}/zeroShop/v1/right`,
        // 0元购商品列表接口V6
        freeBuyGoodsListV6: `${fanxianDomain}/zeroShop/v6/goods`,
        // 搜索列表页检测是否出现0元购弹窗
        checkResultFreeBuyExitDialog: `${fanxianDomain}/zeroShop/v1/right/search`,
        // 0元购检查用户状态，是否淘宝授权，是否已经购买过0元购
        freeBuyCheck: `${domain}/knightCard/promotion/v1_0/free_purchase/check`,
        // 0元购检查商品上架状态
        freeBuyStatusCheck: `${domain}/knightCard/promotion/v1_0/free_purchase/stock/check`,
        // 0元购商品详情
        freeBuyGoodsDetail: `${domain}/knightCard/promotion/v1_0/free_purchase/stock/detail`,
        // 检查用户是否下单
        freeBuyCheckUserOrder: `${domain}/knightCard/promotion/v1_0/free_purchase/countdown_popup`,
        freeBuyDetail: `${domain}/knightCard/abtest/v1_0/free_purchase/goodsDetail`,
        freeBuySNList: `${fanxianDomain}/freePurchase2/goodList`,
        getSnGoodsFreeBuyLink: `${fanxianDomain}/freePurchase2/getSnLink`,
        // 查询0元购资格
        getFreeBuyQualifications: `${fanxianDomain}/zeroShop/v1/right`,
        //返现红包
        unreceivedRedpacket: `${fanxianDomain}/api/commission_redpacket/v1_0/unreceived_redpacket`,
        openRedpacket: `${fanxianDomain}/api/commission_redpacket/v1_0/open_redpacket`,

        // 特权充值
        tqcz: tqcz({
            privilegeDomain,
        }),

        // 抖券商品列表
        douquanGoods: `${domain}/knightCard/goods/v1_0/dq/searchGoods`,
        // 抖券跑马灯用户数据
        getMarqueeData: `${domain}/knightCard/goods/v1_0/dq/getMarqueeData`,
        // 商品详情
        getDouquanGoodsDetail: `${domain}/knightCard/goods/v1_0/dq/getGoodsDetail`,
        // 一卡多吃渲染接口
        cardSplitPage: `${blackCardDomain}/card-split/master-page`,

        // 一卡多吃领取接口
        cardSplitReceive: `${blackCardDomain}/card-split/receive`,
        cardSplitReceiveV2: `${blackCardDomain}/card-split/receive-gt`,

        // nearby「周边」相关接口
        getFilterList: `${privilegeApiDomain}/groupon/shop/categoryList`,
        getTakeoutFilterList: `${blackCardDomain}/groupon/channel-list`,
        getStoreByFilter: `${privilegeApiDomain}/groupon/shop/v1/shopList`,
        getNearbyTakeoutShopList: `${blackCardDomain}/take-out/shop-list`,
        getNearbyTakeoutShopListV2: `${blackCardDomain}/take-out/shop-list-v2`,
        getTakeoutCategory: `${blackCardDomain}/take-out/category`,
        getStoreBySearch: `${blackCardDomain}/groupon/keyword-search`,
        createNearbyOrder: `${blackCardDomain}/groupon/order`,
        createNearbySettlementOrder: `${blackCardDomain}/groupon/payment`,
        getNearbySettlementDiscountInfo: `${blackCardDomain}/groupon/shop-discount-list`,
        calculateNearbySettlementAmount: `${blackCardDomain}/groupon/calculate-payment-amount`,
        getNearbySettlementOrderDetail: `${blackCardDomain}/groupon/order-detail-payment`,
        getNearbyOrderDetail: `${blackCardDomain}/groupon/order-detail`,
        getNearbyOrderStatus: `${blackCardDomain}/groupon/check-paid`,
        getNearbyTicketInfo: `${blackCardDomain}/groupon/check-consume`,
        getShopOpenTime: `${blackCardDomain}/groupon/shop-open-time`,
        getNearbyTopAdShopIndex: `${blackCardDomain}/groupon/fans-shop`,
        getNearbyTopAdShopData: `${blackCardDomain}/groupon/front-shop-info`,
        getNearbySeckillItemList: `${blackCardDomain}/groupon/seckill-list`,
        getNearbySeckillTimeList: `${blackCardDomain}/groupon/show-info`,
        userRedmind: `${blackCardDomain}/user-reminder/store`,
        getMeituanUrl: `${privilegeApiDomain}/groupon/shop/v1/getDealDetailUrl`,

        /*  获取java userid */
        getJavaUserId: `${domain}/knightCard/user/v1_0/getUserInfo`,

        // 获取曹操专车跳转
        getCaocaoUrl: `${domain}/knightCard/caocao/v1_0/getCaocaoUrl`,
        redPacket: redPacket({
            domain,
            fanxianDomain,
        }),

        // 开视频红包红包分销
        redPacketDistribution: redPacketDistribution({
            marketingDomain,
            fanxianDomain,
        }),

        // 瀑布流获取广告位
        getWaterfallAdvert: `${domain}/knightCard/goods/v3/advert`,

        // 分销入口-提现
        withdraw: withdraw({
            blackCardDomain,
        }),
        // 获取分享赚钱详情
        getShareDetail: `${domain}/knightCard/goods/v1/shareDetail`,
        getSNShareDetail: `${fanxianDomain}/api/suning/v1_0/getSNGoodsShareDetail`,

        // 获取分享防封链接
        getShareShortUrl: `${domain}/knightCard/goods/v1/getShareUrl`,
        getShareType: `${blackCardDomain}/order/share_ecard/get-share-type`,
        //现金拉新
        pullCash: pullCash({
            blackCardDomain,
        }),
        //邀请有礼
        invitePolite: invitePolite({
            blackCardDomain,
        }),
        //芝麻轻会员go
        memberGo: memberGo({
            blackCardDomain,
        }),
        // 0元购
        zeroPage: zeroPage({
            blackCardDomain,
        }),
        middlePage: middlePage({
            blackCardDomain,
        }),

        // 通用搜索页
        searchPage: searchPage({
            domain,
        }),
        // 获取团长信息
        getAgentLeaderInfo: `${facadeDomain}/agent-leader/member-level`,

        // cps优化abtest
        getCpsPageAbTest: `${fanxianDomain}/api/public/getCpsPageAbTest`,

        newUser: newUser({
            marketingDomain,
        }),
        // 免费电子卡分享页面粉丝数据
        shareCard: shareCard({
            blackCardDomain,
        }),

        // 品牌特卖 品牌数据
        brandsDetail: `${domain}/knightCard/activity/v1_0/brands/activity`,
        // 品牌下商品分页
        getBrandsGoods: `${domain}/knightCard/activity/v2_0/brands`,
        // 品牌页更多品牌数据
        getMoreBrands: `${domain}/knightCard/activity/v2_0/brands/more`,
        // 激活骑士卡
        activateCard: activateCard({
            blackCardDomain,
            facadeDomain,
        }),

        // 获取用户实名信息
        getUserIdCard: `${domain}/knightCard/user/v1_0/idCard`,
        // 获取用户实名信息
        doVerifyIdCard: `${domain}/knightCard/user/v1_0/idCard/verify`,
        // 问答列表
        getQaList: `${domain}/knightCard/goods/v1_0/qa/list`,
        // 获取小程序码
        getMiniQrCode: `${domain}/knightCard/groupPurchase/v1_0/getMiniQrcodeForGroup`,
        // 拼团商品列表
        getGroupGoodsList: `${domain}/knightCard/groupPurchase/v2_0/goodsInfoRespList`,

        // 福袋开关
        getLuckyBagSwitch: `${marketingDomain}/activity/luckBag/api/getLuckBagOrder`,

        // 淘宝沉浸式
        taobaoImmersive: taobaoImmersive({ domain }),
        // 货到付款
        payment: payment({
            domain: window.location.origin,
        }),
        // 快照中转页列表
        getSnapshotList: `${domain}/knightCard/order/v1_0/snapshot`,
        // 快照详情
        getSnapshotDetail: `${domain}/knightCard/order/v1_0/snapshot/detail`,

        // 商详运营位
        getGoodsAdvert: `${domain}/knightCard/goods/v1_0/goodsAdvert`,

        // 品牌详情
        brandInfo: `${domain}/knightCard/brand/v1_0/brandInfo`,
        addBrandCollect: `${domain}/knightCard/brandCollect/v1_0/addBrandCollect`,
        delBrandCollect: `${domain}/knightCard/brandCollect/v1_0/delBrandCollect`,
        searchBrandGoods: `${domain}/knightCard/brand/v1_0/searchBrandGoods`,
        brandCollectList: `${domain}/knightCard/brandCollect/v1_0/list`,
        // 品牌比价信息
        getBrandGoodsInfo: `${domain}/knightCard/brand/v1_0/getBrandGoodsInfo`,
        // 开发票
        addInvoice: `${domain}/knightCard/invoice/v1_0/add_invoice`,
        // 撤销发票
        cancelInvoice: `${domain}/knightCard/invoice/v1_0/cancel_invoice`,
        // 发票详情
        getInvoiceDetail: `${domain}/knightCard/invoice/v1_0/detail`,
        // 发票详情by订单id
        getInvoiceDetailByOrderId: `${domain}/knightCard/invoice/v1_0/invoices_common_order_id`,
        // 更新发票
        updateInvoice: `${domain}/knightCard/invoice/v1_0/update_invoice`,
        // 是否开过发票
        checkInvoice: `${domain}/knightCard/invoice/v1_0/isInvoice`,
        // 盲投激活
        cardActivate: cardActivate({
            blackCardDomain,
            facadeDomain,
        }),
        // app办卡渠道区分
        cardChannel: cardChannel({ blackCardDomain }),
        // 推荐落地页
        getPushGoodsList: `${domain}/knightCard/abtest/v1_0/personalizedPush/goodsInfoList`,
        // 拼多多推荐
        PDDtopGoodsList: `${fanxianDomain}/api/duoduoke/v1_0/topGoodsList`,
        PDDsearchByLink: `${fanxianDomain}/api/duoduoke/abtest/v1_0/searchByLink`,
        getPddAuth: `${fanxianDomain}/api/duoduoke/v1_0/authority/query`,
        // 百万补贴
        millionSubsidies: millionSubsidies({ fanxianDomain }),

        // 获取所有abtest
        getAllABtest: `${facadeDomain}/ab/v1/h5/allAbTest`,
        // 淘宝相关
        tbModule: tbModule({ domain, fanxianDomain }),
        // 拼多多相关
        pddModule: pddModule({ domain, fanxianDomain }),
        // 京东相关
        jdModule: jdModule({ fanxianDomain }),
        // 个性化推荐开关
        getPersonalRecommendStatus: `${fanxianDomain}/api/userProtocol/v1_0/getPersonalRecommendStatus`,
        changePersonalRecommendStatus: `${fanxianDomain}/api/userProtocol/v1_0/changePersonalRecommendStatus`,
        getPersonaliseSettings: `${domain}/knightCard/personalise/getPersonaliseSettings`,
        updatePersonaliseSettings: `${domain}/knightCard/personalise/updatePersonaliseSettings`,
        tqDiscount: tqDiscount({ blackCardDomain, privilegeDomain }),

        // 供应商
        listAllSupplier: `${domain}/knightCard/common/listAllSupplier`,
        // 一级分类
        listGoodsType: `${domain}/knightCard/common/listGoodsType`,

        // 获取京东购物车链接
        getJdCartUrl: `${fanxianDomain}/jdf/tools/v1_0/cart/transfer`,
        // 沉浸式相关
        immersive: immersive({ domain }),
        // 新cps相关
        cps: cps({ fanxianDomain }),
        AllSalers: AllSalers(),
        //兑换优惠券（语音验证码）相关接口
        couponExchange: couponExchange({ domain }),
        // 极验注册接口
        geetestRegisterOfKnight: `${domain}/knightCard/geetest/v1_0/register`,
        // PHP极验
        geetest: geetest({ blackCardDomain }),
        // 表单页收集
        bookCollect: bookCollect({ blackCardDomain, cardDomain }),
        // 风控
        riskManagement: riskManagement({ blackCardDomain }),
        // 是否金卡会员
        isVipMember: `${vipMemberDomain}/vip-member/vip/mall/v1_0/isVipMember`,
        // 查询金卡信息
        getMemberPackageInfo: `${vipMemberDomain}/vip-member/vip/mall/v1_0/getMemberPackageInfo`,
        // 创建金卡订单
        memberOrderCreate: `${vipMemberDomain}/vip-member/vip/order/v1_0/orderCreate`,
        // 支付方式
        payMethod: `${blackCardDomain}/common/payment-method`,

        // 支付方式V2
        payMethodV2: `${cardDomain}/newPay/v1/payMethodList`,

        // 凑单页加购接口
        addSkuByBuyNumber: `${domain}/knightCard/cart/v1_0/addSkuByBuyNumber`,
        // N元任选凑单购物车商品
        calcCartSaleAndGoods: `${domain}/knightCard/saleActivity/v1_0/calcCartSaleAndGoods`,
        // 优惠券凑单购物车商品
        calcCartGoodsByCartId: `${domain}/knightCard/coupon/v1_0/calcCartGoodsByCartId`,

        // page_view开关
        pageViewSwitch: `${domain}/knightCard/bigData/v1_0/report/get`,

        // 获取微信用户信息
        getWxUserInfo: `${blackCardDomain}/account/get-wx-user`,

        // 获取公共配置
        getFanxianConfig: `${fanxianDomain}/api/public/getValues`,
        // 获取公共配置V2
        getFanxianConfigV2: `${fanxianDomain}/api/public/v2/getValues`,
        // 省钱宝首单激励-订单聚合页-图片
        getSqbFirstOrderPic: `${fanxianDomain}/api/sqb/v1/sqbFirstOrder/orderMerge/pic`,

        // 微信卡包派券
        receiveCouponOfMini: `${domain}/knightCard/wechat/coupon/v1_0/receive`,
        receiveWechatCoupon: `${blackCardDomain}/wechat/receive-coupon`,
        // 拼团微信小程序内嵌搜索页搜索商品
        getGroupWebviewSearchGoods: `${domain}/knightCard/abtest/v1_0/miniProGoodsSearch`,
        // 用户订阅商品降价详情
        getUserGoodsSubscribeDetail: `${domain}/knightCard/userGoods/v1_0/getUserGoodsSubscribeDetail`,
        // 用户订阅商品降价添加订阅
        addUserGoodsSubscribe: `${domain}/knightCard/userGoods/v1_0/addUserGoodsSubscribe`,
        // 微信卡券核销
        receiveCoupon: `${blackCardDomain}/wechat/receive-coupon`,
        // 获取用户商品spu可购买数量
        getUserSpuLimitNum: `${domain}/knightCard/order/v1_0/userCanPurchaseNum`,
        // 获取搜索筛选项
        getListSearchScreenItem: `${domain}/knightCard/abtest/v1_0/listSearchScreenItem`,
        // 卡券管理
        couponManagement: couponManagement({ facadeDomain }),
        // 商家券基本信息
        merchantCoupon: `${domain}/knightCard/wechat/coupon/merchant/v1_0/h5/baseInfo`,
        // H5触发微信卡券的领取
        receiveMerchantCoupon: `${domain}/knightCard/wechat/coupon/merchant/v1_0/h5/receive`,
        // 全球购骑士卡微信配置
        knightWechatConfig: `${blackCardDomain}/frontend_api/jssdk2`,
        // 骑士商城微信配置
        knightShopWechatConfig: `${blackCardDomain}/frontend/jssdk-shop`,
        // 登录用户是否会员
        isMember: `${facadeDomain}/user/common/v1/isMember`,
        // 极验初始化(java版本)
        gtInitV2: `${facadeDomain}/gt/v1/register`,
        // 极验宕机模式图像验证码
        gtImgCaptcha: `${facadeDomain}/gt/v1/imgCaptcha`,
        // 发送短信
        sendMsg: `${facadeDomain}/user/common/v1/sendUserSmsCaptcha`,
        // 极验短信发送V2
        sendGtMsgV2: `${facadeDomain}/sms/v1/sendSmsCaptcha`,
        // 获取授权跳转url
        getBaseAuthorizationUrl: `${wechatDomain}/mp/authorization/v1/getBaseAuthorizationUrl`,
        // wx机器人
        wxRobot: wxRobot({ privilegeDomain }),
        // 生成jsapi签名
        getJsApiSignature: `${wechatDomain}/mp/js/v1/getJsApiSignature`,
        // 支付宝免密支付相关接口
        aliQuickPay: aliQuickPay({ facadeDomain }),
        // 授权码获取openid
        getOpenId: `${wechatDomain}/mp/authorization/v1/getOpenId`,
        // 微信unionId隔离登录
        unionIdIsolateLogin: `${facadeDomain}/login/wechat/v1/unionIdIsolateLogin`,
        // 设置真实手机号
        setRealPhone: `${facadeDomain}/user/common/v1/setRealPhone`,
        // 用户信息
        getFrontUserInfo: `${facadeDomain}/user/common/v1/getFrontUserInfo`,
        // 落地页行为推广上报
        landingTG: `${wechatDomain}/promotion/mini/v1/landing`,
    };
}

// 单品推广
const singleGoods = function({ domain }) {
    return {
        getPriceDetail: `${domain}/knightCard/promotion/v1_0/prize_detail`,
        // 单品
        singleGoodsCaptchaImage: `${domain}/knightCard/promotion/v1_0/captcha_image`,
        singleGoodsCheckCode: `${domain}/knightCard/promotion/v1_0/check_verification_code`,
        singleGoodsSendVerificationCode: `${domain}/knightCard/promotion/v1_0/send_verification_code`,
        createOrder: `${domain}/knightCard/promotion/v1_0/create_order`,
        payQuery: `${domain}/knightCard/promotion/v1_0/pay_query`,
    };
};

// 商超接口
const superMarket = function({ blackCardDomain }) {
    return {
        getSuperMarketList: `${blackCardDomain}/advertise/get-entry`,
        getSuperMarketDetail: `${blackCardDomain}/supermarket/detail`,
        getSuperMarketResult: `${blackCardDomain}/supermarket/result`,
    };
};
// 淘礼金接口
const tBounty = function({ domain }) {
    return {
        getTljPageData: `${domain}/knightCard/taolijinActivity/v1_0/getTljPageData`,
        gainTljUrl: `${domain}/knightCard/taolijinActivity/v1_0/gainTljUrl`,
    };
};

const tqcz = function({ privilegeDomain }) {
    return {
        getRechargeInfoV2: `${privilegeDomain}/recharge/product/v1/detail`,
        tqczPay: `${privilegeDomain}/recharge/order/v1/createOrder`,
        waitForPay: `${privilegeDomain}/recharge/order/v1/waitForPay`,
        rechargeActivityVerify: `${privilegeDomain}/recharge/sku/v1/activityVerify`,
        autoPickCoupon: `${privilegeDomain}/shopCoupon/v1/autoPick`,
    };
};

// 开红包活动
const redPacket = function({ domain, fanxianDomain }) {
    return {
        listRedPacket: `${fanxianDomain}/api/redPacketIncome/v1_0/listRedPacket`,
        openRedPacket: `${domain}/knightCard/redPacket/v1_0/openRedPacket`,
        redPacketRecords: `${fanxianDomain}/api/redPacketIncome/v1_0/redPacketRecords`,
        listRedPacketRecord: `${domain}/knightCard/redPacketIncome/v1_0/listRedPacketRecord`,
        listRedPacketRecordIncome: `${fanxianDomain}/api/redPacketIncome/v1_0/listRedPacketRecord`,
        analyzeRedPacketIncome: `${fanxianDomain}/api/redPacketIncome/v1_0/analyzeRedPacketIncome`,
        recommendGoods: `${domain}/knightCard/abtest/v1_0/hourSpikeGoodsRecommend`,
    };
};

// 红包分销
const redPacketDistribution = function({ marketingDomain, fanxianDomain }) {
    return {
        // 配置
        getConfig: `${fanxianDomain}/api/redpacketDistribution/config/getRedPacketDistributionConfig`,
        // 团队详情
        getClaimProgress: `${fanxianDomain}/api/redpacketDistribution/real/getClaimProgress`,
        // top列表数据
        getTopPartUserData: `${fanxianDomain}/api/redpacketDistribution/top/getTopPartUserData`,
        // 真实列表数据
        getRealPartUserData: `${fanxianDomain}/api/redpacketDistribution/real/getRealPartUserData`,
        // 获取分享信息
        getShareObj: `${fanxianDomain}/api/redpacketDistribution/v1/getShareUrl`,
        // 提醒下线领红包
        pushToPartner: `${fanxianDomain}/api/redpacketDistribution/v1/pushToPartner`,
        // 用户是否微信授权
        userAuthorized: `${marketingDomain}/common/auth/v1_0/authorizedAutoRefresh`,
        // 获取支付信息
        orderCreateReal: `${marketingDomain}/activity/pay/v1_0/payinfo/get`,
        // 创建订单
        orderCreate: `${marketingDomain}/activity/pay/v1_0/payinfo/orderCreate`,
        // 查询订单
        orderQuery: `${fanxianDomain}/api/redPacket/increase/v1_0/info`,
        // 告知后端取消支付
        cancelPay: `${marketingDomain}/activity/pay/v1_0/payinfo/cancel`,
        // 获取订单状态
        checkOrderStatus: `${marketingDomain}/activity/pay/v1_0/deduction_progress`,
    };
};

// 分销入口-提现
const withdraw = function() {
    return {
        // 获取提现信息
        getWithdrawInfo: `/wx_partner/withdraw-info`,
        // 保存支付宝账号
        saveAliAccount: `/wx_partner/save-ali-account`,
        // 支付宝提现
        applyExtractAli: `/wx_partner/apply-extract-to-ali`,
        // 保存微信账号
        saveWxAccount: `/wx_partner/submit_user`,
        // 保存微信用户身份证id
        saveWxIdentity: `/wx_partner/save-identity`,
        // 微信提现
        applyExtractWx: `/wx_partner/apply_extract`,
        // 微信提现公众号版本
        applyExtractWxPublic: `/wx_partner/withdraw-by-wx`,
        //H5登录
        partnerLogin: `/wx_partner/mini-wx-login-to-h5`,
    };
};
// 现金拉新
const pullCash = function({ blackCardDomain }) {
    return {
        // rule: `${blackCardDomain}/cash-invite/rule`,
        inviteIndex: `${blackCardDomain}/cash-invite/master`,
        rewardList: `${blackCardDomain}/cash-invite/reward`,
        qrCode: `${blackCardDomain}/miniwechat/get-qr-code-short-scene`,
        // advertiseUrl: `${blackCardDomain}/cash-invite/ad-config`,
    };
};
// 邀请有礼
const invitePolite = function({ blackCardDomain }) {
    return {
        rule: `${blackCardDomain}/card-invite/invite-rule`,
        inviteIndex: `${blackCardDomain}/card-invite/invite-master`,
        couponList: `${blackCardDomain}/card-invite/get-coupon-list`,
        couponFirstList: `${blackCardDomain}/card-invite/get-first-order-list`,
        qrCode: `${blackCardDomain}/miniwechat/get-qr-code-short-scene`,
        advertise: `${blackCardDomain}/advertise/get-entry`,
    };
};

// 芝麻轻会员go
const memberGo = function({ blackCardDomain }) {
    return {
        manageSign: `${blackCardDomain}/light-member-card/manage-sign`,
        signSuccess: `${blackCardDomain}/light-member-card/sign-success`,
        attendanceStatus: `${blackCardDomain}/light-member-card/watch-log`,
        cancelSignUrl: `${blackCardDomain}/zhima-go/order/cancel-sign`,
    };
};

const newUser = function({ marketingDomain }) {
    return {
        listUserTask: `${marketingDomain}/activity/task/api/list_user_task`,
        userTaskCountdown: `${marketingDomain}/activity/task/api/user_task_countdown`,
    };
};
// 0元购
const zeroPage = function({ blackCardDomain }) {
    return {
        zeroEntry: `${blackCardDomain}/entry/h5`,
        sendSms: `${blackCardDomain}/book/send_sms_captcha`,
        getCard: `${blackCardDomain}/book/e-card-place-order`,
    };
};
// 承载中转页
const middlePage = function({ blackCardDomain }) {
    return {
        getDownloadInfo: `${blackCardDomain}/book/download-book-e-card`,
    };
};
const searchPage = function({ domain }) {
    return {
        getGoodsByPage: `${domain}/knightCard/goods/v1/getGoodsByPage`,
        getBanner: `${domain}/knightCard/goods/v2_0/banners`,
    };
};
// 免费电子卡分享页面粉丝数据
const shareCard = function({ blackCardDomain }) {
    return {
        freeFansList: `${blackCardDomain}/agent-leader/free-fans-list`,
        getPosterImg: `${blackCardDomain}/advertise/get-entry`,
    };
};
// 淘宝ab沉浸式
const taobaoImmersive = function({ domain }) {
    return {
        getProductList: `${domain}/knightCard/tbk/v1_0/official/listItems`, // 获取商品
        getTagList: `${domain}/knightCard/tbk/v1_0/immersive/goodsType`, // 获取分类
    };
};
// 货到付款订单数据
const payment = function({ domain }) {
    return {
        getOrderData: `${domain}/finish/entry`,
    };
};
// 激活骑士卡
const activateCard = function({ blackCardDomain, facadeDomain }) {
    return {
        activateCard: `${facadeDomain}/user/activate/v1/splitCard`,
        sendSms: `${blackCardDomain}/common/sms-captcha`,
        finish: `${blackCardDomain}/card-split/activate-finish`,
    };
};
// 盲投-手机号激活骑士卡
const cardActivate = function({ blackCardDomain, facadeDomain }) {
    return {
        setActivate: `${facadeDomain}/user/activate/v1/autoCardActivate`,
        sendSms: `${blackCardDomain}/common/send-sms-captcha`,
        gtInit: `${blackCardDomain}/gt/register-slide`,
    };
};
// app办卡渠道区分
const cardChannel = function({ blackCardDomain }) {
    return {
        getCardChannel: `${blackCardDomain}/app/get-app-card-link`,
    };
};

// 百万补贴
const millionSubsidies = function({ fanxianDomain }) {
    return {
        getTagList: `${fanxianDomain}/api/bwbt/tag/v1/list`, // 标签列表
        getRedPacketBalance: `${fanxianDomain}/api/bwbt/redPacket/v1/balance`, // 红包余额
        isFirst: `${fanxianDomain}/api/bwbt/redPacket/v1/check/first`, // 是否第一次进入活动
        grabRedpacket: `${fanxianDomain}/api/bwbt/redPacket/v1/grab`, // 抢红包
        getRedPacketList: `${fanxianDomain}/api/bwbt/redPacket/v1/period/list`, // 红包列表
        getGoodsDetail: `${fanxianDomain}/api/bwbt/goods/v1/detail`, // 商品详情
        grabGoods: `${fanxianDomain}/api/bwbt/goods/v1/grab`, // 抢购商品
        getGoodsList: `${fanxianDomain}/api/bwbt/goods/v1/list`, // 商品列表
        getPeopleSwipe: `${fanxianDomain}/api/bwbt/goods/v1/marquee`, // 跑马灯
        closeRemind: `${fanxianDomain}/api/bwbt/goods/v1/remind/close`, // 关闭提醒
        createRemind: `${fanxianDomain}/api/bwbt/goods/v1/remind/create`, // 创建提醒
        pushConfig: `${fanxianDomain}/api/bwbt/goods/v1/calendar`, // 分享配置
    };
};
// 淘宝相关
const tbModule = function({ domain, fanxianDomain }) {
    return {
        getAliBcDetail: `${domain}/knightCard/goods/v1_0/tbk/getCartTransferData`, // 阿里百川详情
        checkFilling: `${domain}/knightCard/sqb/v1_0/check`, // 检测备案
        getFreeBuyAlibcDetail: `${fanxianDomain}/h5/v1_0/alibc/getCartTransferData`, // 0元购阿里百川详情
    };
};
// 拼多多相关
const pddModule = function({ domain, fanxianDomain }) {
    return {
        checkFilling: `${fanxianDomain}/api/duoduoke/v1_0/authority/query`, // 检测备案
        getPromotionUrl: `${domain}/knightCard/spreader/v1_0/getPromotionUrl`, // 转链
    };
};
// 京东相关
const jdModule = function({ fanxianDomain }) {
    return {
        getPromotionUrl: `${fanxianDomain}/JDChannel/v3_0/promotion/link`,
        getJdDetailImg: `${fanxianDomain}/api/jdjf/v1_0/queryImagsDetail`,
    };
};

// 特权优惠相关：骑士币、返现折扣
const tqDiscount = ({ blackCardDomain, privilegeDomain }) => {
    return {
        getUserAssets: `${blackCardDomain}/user-assets/detail`,
        getPayBestPlan: `${blackCardDomain}/order-settle/calc`,
        getPayBestPlanV2: `${privilegeDomain}/price/v1/order/singleCalculate`,
    };
};

// 沉浸式相关
const immersive = ({ domain }) => {
    return {
        getSupplierList: `${domain}/knightCard/goods/v1_0/fends/immersion`, // 获取供应商类目
    };
};

// 新cps相关
const cps = ({ fanxianDomain }) => {
    return {
        getRecommendProductList: `${fanxianDomain}/api/material/items/choice`,
        getTypeProductList: `${fanxianDomain}/api/material/items/type`,
    };
};
// 全民分销
const AllSalers = () => {
    return {
        getMasterInfo: `/wx_partner/master-info`, // 主态
        getInviteList: `/wx_partner/period-invite-list`, // 本期邀请列表
        getHistoryInviteList: `/wx_partner/history-invite-list`, // 历史邀请列表
        getRewardList: `/wx_partner/prev-reward-list`, // 历史邀请列表
        suggestPhoneUrl: `/wx_partner/login-token-by-card-phone`, //绑定了手机号的登录
        loginUrl: `/wx_partner/login-token-by-sms`, //验证码登录
        transferUrl: `/wx_partner/transfer`, //数据转移
        miniCode: `/wx_partner/mini-wx-qr-code`,
        getShareText: `/wx_partner/material_text`, // 分享链接
        checkRewardUrl: '/wx_partner/check-reward', //是否允许分享
        getAdvertise: `/advertise/get-entry`, //广告位
    };
};
// PHP极验
const geetest = () => {
    return {
        registerSlide: `/gt/register-slide?t=${new Date().getTime()}`, // 极验初始化
        sendSmsCode: `/common/send-sms-captcha`, // 获取验证码
    };
};

// 兑换优惠券（接入语音验证码）相关接口
const couponExchange = ({ domain }) => {
    return {
        safCheckOfCouponList: `${domain}/knightCard/coupon/v1_0/exchangeCoupon/safCheck`,
        voiceCallOfCouponList: `${domain}/knightCard/coupon/v1_0/exchangeCoupon/send_verification_code`,
        exchangeCouponByCodeOfCouponList: `${domain}/knightCard/coupon/v3_0/exchangeCouponByCode`,
    };
};

// 表单收集
const bookCollect = ({ blackCardDomain, cardDomain }) => {
    return {
        getFinishData: `${blackCardDomain}/card/get-channel-info`, // 获取完成页配置信息
        getPayData: `${blackCardDomain}/card/book/add-ecard-by-visitor-token`, // 获取支付参数
        callPay: `${blackCardDomain}/common/call-pay`,
        getToken: `${blackCardDomain}/login/login-by-visitor-token`, // 获取token
        isPaid: `${blackCardDomain}/card/order/order-paid`, //订单是否支付
        getNewPayData: `${blackCardDomain}/card/book/add-ecard-by-login-token`, // 用户级别下单办卡
        callPayV2: `${cardDomain}/newPay/v1/callPay`,
    };
};
// 风控
const riskManagement = ({ blackCardDomain }) => {
    return {
        riskCode: `${blackCardDomain}/common/send-voice-captcha`, // 风控流程-发送语音验证码
    };
};
// 会员卡相关
const couponManagement = ({ facadeDomain }) => {
    return {
        checkCard: `${facadeDomain}/memberCard/v1/checkCard`,
        getCardExt: `${facadeDomain}/memberCard/v1/getCardExt`,
    };
};

// 微信机器人
const wxRobot = ({ privilegeDomain }) => {
    return {
        // 微信授权获取用户ID
        robotAuth: `${privilegeDomain}/wechat/robot/url/v1/auth`,
        // 外卖机器人取链
        getTakeoutUrl: `${privilegeDomain}/wechat/robot/url/v2/getTakeoutUrl`,
        // 获取用户信息
        getUserInfo: `${privilegeDomain}/wechat/robot/rebate/v1/getUserInfo`,
        // 获取返现列表
        getCashList: `${privilegeDomain}/wechat/robot/rebate/v1/getCashList`,
        // 提现
        cash: `${privilegeDomain}/wechat/robot/rebate/v1/cash`,
    };
};
// 支付宝免密支付
const aliQuickPay = ({ facadeDomain }) => {
    return {
        // 校验短信验证码
        checkSmsCaptcha: `${facadeDomain}/user/common/v1/checkSmsCaptcha`,
        // 关闭免密支付
        relieve: `${facadeDomain}/user/account/secretFreePay/v1/unSign`,
        // 设备认证
        verifyDevice: `${facadeDomain}/user/account/secretFreePay/v1/verifyDevice`,
        // 是否有签约免密支付
        hasSign: `${facadeDomain}/user/account/secretFreePay/v1/check`,
    };
};
